import { render } from "./ReaderSettings.vue?vue&type=template&id=61b58e14"
import script from "./ReaderSettings.vue?vue&type=script&lang=js"
export * from "./ReaderSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__